/**
 * Hook-free translator for pages whose copy lives outside the i18n key files.
 * `tr("Some English text")` looks the string up in the PHRASES dictionary for
 * the active language and falls back to the English literal.
 *
 * The LanguageProvider remounts its subtree when the language changes, so
 * components using tr() re-render with the new language.
 */
import { PHRASES } from "@/lib/i18nPhrases";

export const currentLang = () => {
    try {
        return localStorage.getItem("vt_lang") || "en";
    } catch {
        return "en";
    }
};

export const tr = (s) => {
    if (typeof s !== "string" || !s) return s;
    const dict = PHRASES[currentLang()];
    return (dict && dict[s]) || s;
};

export default tr;
